import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  [key: string]: {
    status?: ReduxStateType;
    data?: any[];
    totalRecords?: number;
  };
}

const initialState: InitialState = {};

const getPostIgnoreTopSlice = createSlice({
  name: "getPostIgnoreTop",
  initialState,
  reducers: {
    getPostIgnoreTopStart: (
      state,
      action: PayloadAction<{
        id: string;
        awardId: string;
        sort: string;
        limit?: string | number;
        offset?: string | number;
      }>
    ) => {
      const data = state[action.payload.id]?.data ?? [];
      state[action.payload.id] = {
        status: ReduxStateType.LOADING,
        data,
        totalRecords: 0,
      };
    },
    getPostIgnoreTopSuccess: (
      state,
      action: PayloadAction<{
        id: string;
        data: any[];
        totalRecords: number;
      }>
    ) => {
      state[action.payload.id] = {
        status: ReduxStateType.SUCCESS,
        data: [...state[action.payload.id].data, ...action.payload.data],
        totalRecords: action.payload.totalRecords,
      };
    },
    getPostIgnoreTopFailed: (state, action: PayloadAction<{ id: string }>) => {
      state[action.payload.id] = {
        status: ReduxStateType.ERROR,
        data: [],
      };
    },
    resetPostIgnoreTop: (state, action: PayloadAction<{ id: string }>) => {
      state[action.payload.id] = {};
    },
  },
});

export const {
  getPostIgnoreTopStart,
  getPostIgnoreTopSuccess,
  getPostIgnoreTopFailed,
  resetPostIgnoreTop,
} = getPostIgnoreTopSlice.actions;

export default getPostIgnoreTopSlice.reducer;
